
import React from "react";
import { useNavigate } from "react-router-dom";
// import { contextData } from "../../../App";
import BgAnimation from "../Skills-Page-Animation/BgAnimation";
import "./Skills.css";

const Skills = ({tools, subject }) => {
  // const contextValue = useContext(contextData);
  // const { tools, subject } = contextValue;
  const toolsKit = tools || [];
  const navigate = useNavigate();
  // const toolsKit = tools?.tools || [];

  return (
    <>

    
      <div className="skills-container">
        <BgAnimation />

        <div className="skills-content">
          <h2 className="section-title">Skills You'll Learn</h2>
          <p className="subject-text">{subject}</p>

          <div className="skills-grid">
            {toolsKit.map((v, index) =>
              v.front_end_tool ? (
                <div key={index} className="skill-card">
                  <h3 className="skill-category">{v.front_end_tool.front_end_name}</h3>
                  <div className="skill-icons">
                    {[...Array(7)].map(
                      (_, i) =>
                        v.front_end_tool[`front_tool${i + 1}`] && (
                          <div key={i} className="skill-item">
                            <img
                              src={v.front_end_tool[`front_tool${i + 1}`]}
                              alt=""
                              className="skill-icon"
                            />
                            <p>{v.front_end_tool[`front_tool${i + 1}_name`]}</p>
                          </div>
                        )
                    )}
                  </div>
                </div>
              ) : null
            )}

            {toolsKit.map((v, index) =>
              v.back_end_tool ? (
                <div key={index} className="skill-card">
                  <h3 className="skill-category">{v.back_end_tool.back_end_name}</h3>
                  <div className="skill-icons">
                    {[...Array(7)].map(
                      (_, i) =>
                        v.back_end_tool[`back_tool${i + 1}`] && (
                          <div key={i} className="skill-item">
                            <img
                              src={v.back_end_tool[`back_tool${i + 1}`]}
                              alt=""
                              className="skill-icon"
                            />
                            <p>{v.back_end_tool[`back_tool${i + 1}_name`]}</p>
                          </div>
                        )
                    )}
                  </div>
                </div>
              ) : null
            )}

            {toolsKit.map((v, index) =>
              v.database ? (
                <div key={index} className="skill-card">
                  <h3 className="skill-category">{v.database.data_base_name}</h3>
                  <div className="skill-icons">
                    {[...Array(2)].map(
                      (_, i) =>
                        v.database[`data_tool${i + 1}`] && (
                          <div key={i} className="skill-item">
                            <img
                              src={v.database[`data_tool${i + 1}`]}
                              alt=""
                              className="skill-icon"
                            />
                            <p>{v.database[`data_tool${i + 1}_name`]}</p>
                          </div>
                        )
                    )}
                  </div>
                </div>
              ) : null
            )}
          </div>

          <div className="register-btn-container">
            <button className="register-btn" onClick={() => navigate("/Mail")}>
              Register Here
            </button>
          </div>
        </div>
      </div>
    </>
  );
};

export default Skills;